import type { EntityTypeEnum } from 'modules/app/types';
import type { MayBe } from 'modules/global/typing/common/common';

import type { SocketAction, SocketTopic } from './types/actions';

export const ROOT = '@@SOCKET';
export const ERROR = `${ROOT}/ERROR`;
export const CLOSED = `${ROOT}/CLOSED`;
export const CONNECT = `${ROOT}/CONNECT`;

export const CONNECTED = `${ROOT}/CONNECTED`;
export const SUBSCRIBED = `${ROOT}/SUBSCRIBED`;
export const UNSUBSCRIBED = `${ROOT}/UNSUBSCRIBED`;

export const SEND = `${ROOT}/SEND`;

export const actionTypeFormatter = (topic: MayBe<SocketTopic>, entityType: EntityTypeEnum, action: SocketAction): string =>
  `${ROOT}/TOPIC:${topic}/${entityType}/${action}`;
